export const DateConst = Object.freeze({
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
});

export const BlankOrderGuideGroup = Object.freeze({
    allowCopyFunction: false,
    allowPartialCaseOrders: false,
    allowSameDayDeliveries: false,
    createDate: new Date(),
    createdBy: '',
    creditEmailGroupAddress: '',
    customSalesRepDeliveryDate: false,
    deleteFlag: false,
    emailGroupAddress: '',
    modifiedBy: null,
    modifyDate: '',
    multipleDayOrderGuide: false,
    orderGuideGroupId: 0,
    orderGuideGroupName: '',
    orderHoO_End: '',
    orderHoO_Start: '',
    sameDayOrderHoO_End: '',
    sameDayOrderHoO_Start: '',
    showBrand: false,
    showComments: false,
    showIncoming: false,
    showPastDelivery: false,
    showPricing: false,
    showShortCode: false,
    showStoreComments: false,
    showSubs: false,
    showTotalOrder: false,
    useNWSProducts: false,
    useNWSRules: false,
    allowMultipleDayOrderGuide: false,
    showGroupBuyerNotes: false,
    allowAutoUpdateOrders: false,
    lockOriginalLineAfterSub: false
});


// WEBPACK FOOTER //
// ./src/components/shared/consts.js